

import React, { Component } from "react";
import {
  Button,
  Segment,
  Form,
  Input,
  Checkbox,
  Dimmer,
  Loader,
  Header
} from "semantic-ui-react";
import { Link } from 'react-router-dom'
import Cookie from "../../services/cookie";
import { history } from "../../services/history";
import API from "../../apiCalls/accountAPI";
import Images from '../../config/images'
import { get } from 'lodash';
import { getCookie } from "../../util/index";
import { brokerRoAccess, brokerType, OTP_TESTING } from "../../util/constants";
import { getQueryVariable } from "../../apiCalls/jobInfo";


class Login extends Component {
  constructor() {
    super();
    this.state = {
      username: "",
      password: "",
      rememberMe: "",
      usernameError: false,
      passwordError: false,
      showPopup: false,
      showLoginCard: true,
      showKNEmailCard: false,
      showOTPCard: false,
      knEmail: "",
      otp: "",
      loading: false,
      failedLogin: false,
      errorMessage: "",
      kxToken: "",
      useCurrentEmail: false,
      page: getQueryVariable("page")
    };
    window.addEventListener('message', (event) => {
      console.log("____event.origin___", event.data)
      sessionStorage.removeItem('customerId')
      if(event.data.callSentToIframe == 'setKxToken'){
        console.log("eventttttt from the login:", event.data)
          Cookie.set(
          window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN,
          event.data.valueSentToIframe,
          3
        );
          sessionStorage.setItem('customerId',event.data.customerId)
      }
    });
  }

  componentWillMount = () => {
    this.setState({
      tokenUrl:
        window.location.hostname === "localhost"
          ? "localhost:3000"
          : "klearnow.com"
    });
  };

  checkEnv = () => {
    let URL = window._env_.REACT_APP_BROKER_API_URL;
    let env = URL.split('/');
    env = env[3];
    env = env.replace('-broker', '');

    if(["staging",'pre-prod',"dev","qat"].includes(env)){
      return false;
    }
    return true;
  }

  componentDidMount() {
    let parameterKxBrokerToken = getQueryVariable('myKxToken')
    if(parameterKxBrokerToken){
      Cookie.set(
        window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN,
        parameterKxBrokerToken,
        3
      );
      this.setState({ toNextPage: true });
    } else if (this.getCookieValue(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN) !== "" && !this.state.toNextPage) {
      let parentThis = this;
      API.getKxuser(this.getCookieValue(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN))
        .then((response) => {
          console.log('reqsponse: ', response);
          if(response.status==200){
            parentThis.setState({ toNextPage: true });
          }
            
        })
    }
  }

  togglePopup() {
    const { username } = this.state;
    this.setState({
      showPopup: !this.state.showPopup,
      username
    });
  }

  renderLoader = () => {
    if (this.state.loading) {
      return (
        <div className="loader-container">
          <Dimmer active inverted>
            <Loader size="big" inverted>Logging in...</Loader>
          </Dimmer>
        </div>
      );
    }
  };

  getCookieValue = name => {
    let b = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return b ? b.pop() : "";
  };

  handleChange = (e, { name, value }) => {
    if(name === "username" && OTP_TESTING && (brokerRoAccess.includes(value) || this.validateKnEmail(value))){
      this.setState({showKNEmailCard: true});
    }else if(name === "username" && OTP_TESTING && !brokerRoAccess.includes(value)){
      this.setState({showKNEmailCard: false});
    }
    this.setState({ [name]: value });
  }
  
  handleCurrentEmailCheck = (name, value) => {
    this.setState({ [name]: value });
  }

  showError = (errorMsg) => {
    this.setState({ loading: false, failedLogin: true, errorMessage: errorMsg }, () => {
      setTimeout(() => {
        this.setState({ failedLogin: false, errorMessage: "" });
      }, 1200)
    })
  }

  getUserData = () => {
    API.getUserInfo(this.state.kxToken)
      .then((responses) => {
        return Promise.all(responses.map(function (res) {
          return res.json();
        }));
      })
      .then((responseData) => {
        let kxUserData = responseData[0].eventMessage;
        
        // additional authentication for Broker RO
        if(this.checkEnv() && kxUserData.userBasicInfo.typeOfUser === brokerType[0] && kxUserData.userBasicInfo.email === brokerRoAccess[0]){
        // if(this.checkEnv() && this.validateKnEmail(this.state.username)){
          this.setState({showLoginCard: false, showKNEmailCard: true, loading: false})
        }else{
          this.sendToBrokerDashboard();
        }
      }).catch(err => {
        this.setState({loading: false});
        console.error(err);
      })
  }

  sendToBrokerDashboard = () => {
    this.setTokenCookies(this.state.kxToken);
    history.push("/broker-panel"+window.location.search);
    window.location.reload(true);
    this.setState({ toNextPage: true });
    localStorage.setItem("showedAlertForSVB","false")
  }

  setTokenCookies = () => {
    const { kxToken } = this.state;
    Cookie.set(
      window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN,
      kxToken,
      3
    );
    Cookie.set(
      "kxEntrySummaryToken",
      kxToken,
      3
    );
  }

  getUserToken = () => {
    const { username, password } = this.state;
    this.setState({ username, password, loading: true });
    this.setState({ submitted: true });
    if (this.state.username && this.state.password) {
      API.login(this.state.username, this.state.password)
        .then(response => {
          return response.json();
        })
        .then(responseData => {
          let responseMessageCode = get(responseData, "eventMessage.header.code", null);
          if (responseMessageCode !== 200) {
            this.setState({loading: false});
            if (responseData.msg === "Email does not exist") {
              this.showError("Email is not registered.")
            } else if (responseData.msg === "Invalid password") {
              this.showError("Invalid password.")
            }
            else if (responseData.msg === "Invalid userName/password") {
              this.showError("Invalid username or password.")
            }
            else if (responseData.msg === "Unauthorized ,You are attempting to log into the wrong panel.") {
              this.showError("Invalid username or password.")
            }
          }
          else {
            this.setState({kxToken: responseData.eventMessage.user.kxToken},()=>{
              this.getUserData();
            });
          }
        });
    }
  }

  validateKnEmail = (email) => {
    let knEmail = String(email).toLowerCase();
    return /@klearnow.com$/.test(knEmail);
  }

  resendOtp = () => {
    this.sendKnEmail();
  }

  
  sendKnEmail = () => {
    this.setState({ loading: true });

    let email = this.state.username,
      knEmail = "";
    if(brokerRoAccess.includes(email) || !this.state.useCurrentEmail){
      knEmail = this.state.knEmail;
    }else if(this.state.useCurrentEmail){
      knEmail = email;
      this.setState({knEmail: email});
    }else{
      knEmail = email;
      this.setState({knEmail: email});
    }
    
    let hashedPassword = this.state.password;

    // validate email
    if (!this.validateKnEmail(knEmail)) {
      return this.showError("Invalid KN Email.");
    }

    let portal = `broker-${this.state.username.split("@")[0]}`

    API.sendKnEmail({ email, knEmail, portal, hashedPassword }).then(res => {
      if (res.data.eventMessage.code != 200) {
        this.setState({loading: false});
        return this.showError(res.data.eventMessage.msg);
      } else {
        this.setState({ loading: false, showKNEmailCard: false, showLoginCard: false, showOTPCard: true });
      }
    }).catch(err => {
      console.error(err);
      this.setState({ loading: false });
      return this.showError(err?.response?.data?.msg || (err+"") );
    })
    
  }

  
  validateOTP = (otp) => {
    return String(otp)
    .match(
      /^[0-9]{6}$/
    );
  }

  checkGeneratedOTP = () => {
    let {otp, knEmail, username, password} = this.state;
    let typeOfUser = "BROKER_USER";

    if(!otp){
      return this.showError("Empty Field.");
    }

    if(!this.validateOTP(otp)){
      return this.showError("Invalid OTP")
    }

    this.setState({loading: true});

    let body = {token: otp, email: username, knEmail, hashedPassword: password, typeOfUser};

    API.authenticateGeneratedOTP(body).then(res => {
      if (res.data.eventMessage.header.code != 200) {
        return this.showError("Wrong OTP.");
      } else {
        this.setState({kxToken: res.data.eventMessage.user.kxToken},()=>{
          // this.getUserData();
          this.sendToBrokerDashboard();
       });
      }
    }).catch(err => {
      console.error(err);
      this.setState({ loading: false });
    })
  }

  handleSubmit = evt => {
    evt.preventDefault();
    if(OTP_TESTING && this.state.showKNEmailCard){
      this.sendKnEmail();
    }else if(OTP_TESTING && this.state.showOTPCard){
      this.checkGeneratedOTP();
    }else if(this.state.showLoginCard){
      this.getUserToken();
    }
  };

  backToLogin = () => {
    this.setState({showKNEmailCard: false, showLoginCard: true, showOTPCard: false, password: "", knEmail: "", otp: "", username: "", kxToken: ""})
  }

  render() {
    
    if (this.state.toNextPage === true) {
      window.location.pathname = this.state.page || "/broker-panel";
    }

    const { username, password, showLoginCard, showKNEmailCard, showOTPCard, knEmail, otp, failedLogin } = this.state;
    return (
      <div>
        <Segment padded="very" className="login-left-body" style={{flexDirection:'column'}}>
          

          <Form onSubmit={this.handleSubmit} className="login-container">
            <center><img id='kxLogo' src={Images.knlogonew} /></center>
            
              {showOTPCard ? <Header as="h5" className="login">
                Please enter OTP</Header> : showKNEmailCard ? <Header as="h5" className="login">Please enter your Klearnow Email</Header> : ""}
            
            {showLoginCard && <Form.Field>
              <label className="login-label">EMAIL *</label>
              <Input
                fluid
                className="username"
                id="txtInputName"
                error={this.state.usernameError}
                name="username"
                value={username}
                onChange={this.handleChange}
              />
              {OTP_TESTING && !brokerRoAccess.includes(username) && this.validateKnEmail(username) && <Checkbox className="login-checkbox" label='Use same email id to get OTP' onClick={(e, data) => this.handleCurrentEmailCheck("useCurrentEmail", data.checked)} />}
              <label className="login-label">PASSWORD *</label>
              <Input
                fluid
                error={this.state.passwordError}
                name="password"
                type="password"
                value={password}
                className="pw"
                id="txtPassword"
                onChange={this.handleChange}
              />
              {showKNEmailCard && <React.Fragment>
                <label className="login-label">KN EMAIL *</label>
                <Input
                  fluid
                  className="username"
                  id="txtInputName"
                  error={this.state.usernameError}
                  name="knEmail"
                  onChange={this.handleChange}
                  disabled={this.state.useCurrentEmail}
                  value={this.state.useCurrentEmail ? username : knEmail}
                />
              </React.Fragment>}
              
            </Form.Field>
            }
            {showOTPCard && <Form.Field>
              <label className="login-label">ENTER OTP *</label>
              <Input
                fluid
                className="username"
                id="txtInputName"
                error={this.state.usernameError}
                name="otp"
                value={otp}
                onChange={this.handleChange}
              />
            </Form.Field>}
            
            {failedLogin && <center className="bad-credentials">{this.state.errorMessage}</center>}
            <Button
              fluid
              className="login"
              onClick={this.handleSubmit}
              type="submit"
              color="twitter"
              size="small"
              disabled={!this.state.username || !this.state.password}
            >
              {showKNEmailCard ? "GET OTP" : showOTPCard ? "SUBMIT" : "LOGIN"}
            </Button>
            <br />
            <br/>
            <center>
              {this.state.showLoginCard && <>
                <Link to='/forgot' className='forgotLogin'> Forgot Password? </Link>
                <br />
                <br />
                <span className='forgotLogin'>Don't have an account? </span>
                <a href={window._env_.REACT_APP_SIGNUP_URL_BROKER}
                  className="forgotLogin"
                >
                  Sign up!
                </a>
              </>}
              {this.state.showOTPCard && <p className="backToLogin" onClick={this.resendOtp}>Resend OTP</p>}
              {!this.state.showLoginCard && <p className="backToLogin" onClick={this.backToLogin}>Back to Login</p>}
            </center>
          </Form>
        </Segment>
        {
          this.state.loading && this.renderLoader()
        }
      </div>
    );
  }
}

export default Login;
